import CalculatorService from "@/services/Calculator/CalculatorService";
import {InterestRate, Rate, UpgradLoanOverview, UpgradLoanPerMonth, UpgradLoanSchedule} from "@/lib/types/calulator/upgrad";
import {ExchangeCurrency} from "@/lib/types/config";

class UpgradService extends CalculatorService {
    private partnerName = 'upgrad'
    private downPaymentType = 'down-payment'
    private rateType = 'rate'
    static serviceFeeConfig = 'service/upgrad/percent'
    private downPaymentRates:InterestRate[] = []
    private rates:InterestRate[] = []
    private serviceRate = 0

    constructor(rates:Rate, serviceRate:number = 0) {
        super();
        this.filterUpgradRates(rates)
        this.serviceRate = serviceRate
    }

    private filterUpgradRates = (rates:Rate) => {
        this.downPaymentRates = []
        this.rates = []
        rates.interest_rate.forEach((rate:InterestRate) => {
            if(rate.partner == this.partnerName) {
                if(rate.type == this.downPaymentType) {
                    this.downPaymentRates = [...this.downPaymentRates,rate]
                }else if(rate.type == this.rateType){
                    this.rates = [...this.rates,rate]
                }
            }
        })
    }

    private getDownPaymentRate = (month:number):InterestRate | any => {
        return this.downPaymentRates.find((item, index) => {
            return item.Duration == month
        })
    }

    private getRate = (month:number):InterestRate | any => {
        return this.rates.find((item, index) => {
            return item.Duration == month
        })
    }

    public getMaxDelayMonth = (month:number):{month:number, months:number[]} => {
        let maxDelayMonth = Math.floor(month / 2)
        maxDelayMonth = maxDelayMonth > 12 ? 12 : maxDelayMonth
        let maxDelayMonths:number[] = []
        for(let i = 1; i <= maxDelayMonth; i++) {
            maxDelayMonths = [...maxDelayMonths,i]
        }
        return {
            month: maxDelayMonth,
            months: maxDelayMonths,
        }
    }

    public calculateLoanOverview = (amount:number,month:number,prepayAdditionalAmount:number,delayMonth:number):UpgradLoanOverview => {
        let downPaymentRate:InterestRate = this.getDownPaymentRate(month)
        let rate:InterestRate = this.getRate(month)
        let prepayAmount = Math.round(amount * downPaymentRate.Value)

        return{
            baseAmount: amount,
            loanAmount: amount - prepayAmount - prepayAdditionalAmount,
            prepayAmount: prepayAmount,
            prepayAdditionalAmount: prepayAdditionalAmount,
            loanRate: rate.Value,
            serviceRate: this.serviceRate,
            prepayRate: downPaymentRate.Value,
            duration: month,
            rateOnlyDuration: delayMonth
        }
    }

    public calculateLoanSchedule = (amount:number,month:number,prepayAdditionalAmount:number,delayMonth:number):UpgradLoanSchedule => {
        let sumDebtRemainAmount = 0
        let sumRateAmount = 0
        let sumBaseAmount = 0
        let sumPaymentAmount = 0
        let paymentPerMonthWithoutInterest = 0
        let loanSchedule:UpgradLoanPerMonth[] = []

        let downPaymentRate:InterestRate = this.getDownPaymentRate(month)
        let rate:InterestRate = this.getRate(month)
        let finaleRate:number = rate.Value + this.serviceRate

        let prepayAmount = amount * downPaymentRate.Value
        let loanAmount = amount - prepayAmount - prepayAdditionalAmount
        let pmtAmount = this.pmt(loanAmount,month,finaleRate)

        let schedulePerMonth:UpgradLoanPerMonth = {
            currentMonth: 0,
            downDebtRemainAmount: 0,
            downRateAmount: 0,
            downBaseAmount: 0,
            paymentAmount: 0
        }

        for(let i = 1; i <= delayMonth + month; i++){
            if(i <= delayMonth){
                schedulePerMonth = {
                    currentMonth: i,
                    downDebtRemainAmount: loanAmount,
                    downRateAmount: Math.ceil(loanAmount * finaleRate / 12),
                    downBaseAmount: 0,
                    paymentAmount: Math.ceil(loanAmount * finaleRate / 12)
                }
                paymentPerMonthWithoutInterest = Math.ceil(loanAmount * finaleRate / 12)
            }else{
                let downDebtRemainAmount = schedulePerMonth.downDebtRemainAmount - schedulePerMonth.downBaseAmount
                downDebtRemainAmount = downDebtRemainAmount < 0 ? downDebtRemainAmount * (-1) : downDebtRemainAmount
                let downRateAmount = Math.ceil(downDebtRemainAmount * finaleRate / 12)
                schedulePerMonth = {
                    currentMonth: i,
                    downDebtRemainAmount: downDebtRemainAmount,
                    downRateAmount: downRateAmount,
                    downBaseAmount: pmtAmount - downRateAmount,
                    paymentAmount: pmtAmount
                }
            }
            loanSchedule = [...loanSchedule,schedulePerMonth]
            sumDebtRemainAmount = schedulePerMonth.downDebtRemainAmount
            sumRateAmount += schedulePerMonth.downRateAmount
            sumBaseAmount += schedulePerMonth.downBaseAmount
            sumPaymentAmount += schedulePerMonth.paymentAmount
        }

        return {
            sumDebtRemainAmount,
            sumRateAmount,
            sumBaseAmount,
            sumPaymentAmount,
            paymentPerMonthWithoutInterest,
            paymentPerMonthAmount: schedulePerMonth.paymentAmount,
            loanSchedule
        }
    }

}
export default UpgradService